import React from "react";
import classnames from "classnames";
import { PlusIcon, VerticalDotsIcon } from "@aureskonnect/react-ui";
import { useSnapshot } from "valtio";
import { useTranslation } from "react-i18next";
import { uuid } from "uuidv4";

import { store as useStore } from "../../../../components/VerticalLayout/store";
import {
    setIsHistoryModalOpened,
    setIsInlineErrorCleared,
    store,
    setActions,
    setIsActionsClicked,
    setIsEdited,
    setIsLoading,
    setKey,
} from "../store";

import ErrorToast from "../../../../components/Common/ErrorTost";
import { ConfirmationArchive } from "../ConfirmationArchive";

import { CustomMainColorIconButton } from "@components/Common/CustomMainColorIconButton";
import { CustomMainColorButtonWithIcon } from "@components/Common/CustomMainColorButtonWithIcon";
import {
    archivedSaleSupport,
    ArchivedSaleSupportFranchise,
    saleSupportExistInShops,
    handleArchiveSaleSupportHelper,
} from "../utils/saleSupportHelpers";
import { useFetchGlobal } from "../../../../api/hooks";
import { GetSalesModesTypesAndTagsV2 } from "@pages/SettingGeneral/ModeOfSale/ModeOfSales/helper";

export function CustomSideFilter({
    selectedRows,
    saleSupport,
    setIsInInitializationModalOpened,
    setLocalFilterActive,
    setIsAddSaleSupportClicked,
    isAddSaleSupportClicked,
    setIsModalConfirmationOpened,
    isModalConfirmationOpened,
    isArchivedSaleSupportClicked,
    setIsArchivedSaleSupportClicked,
    setLimit,
    setSalesModesTypesAndTag,
}: any) {
    const { t } = useTranslation();
    const { fetchGlobal } = useFetchGlobal();

    const { oneShop, userID, franchiseID, shopID, operatorID } = useSnapshot(
        useStore
    );
    const {
        numberArchived,
        numberActive,
        isHistoryModalOpened,
        shopsSaleSupportData,
        isInlineErrorCleared,
        listFranchiseArchived,
        isEdited,
        isActionsClicked,
        modify,
        isLoading,
    } = useSnapshot(store);
    const shopId = oneShop ? shopID : 0;
    const uuidUser = localStorage.getItem("uuidUser");
    let dataArchive: any[] = [];
    if (!oneShop) {
        dataArchive = archivedSaleSupport(shopsSaleSupportData);
    } else {
        dataArchive = ArchivedSaleSupportFranchise(listFranchiseArchived);
    }

    const [isActive, setIsActive] = React.useState<boolean>(false);
    const [
        isArchivedValidationModalOpened,
        setIsArchivedValidationModalOpened,
    ] = React.useState<boolean>(false);
    const [isValidateClicked, setIsValidateClicked] = React.useState<boolean>(
        false
    );

    async function handleArchiveSaleSupport(value: boolean) {
        const result = await handleArchiveSaleSupportHelper({
            userID,
            franchiseID,
            operatorID,
            shopID,
            uuidUser,
            isArchived: value,
            selectedRows,
            t,
            fetchGlobal,
            setIsLoading,
            setLimit,
        });

        // Refresh data if successful
        if (result.success) {
            setKey(uuid());
        }

        setIsValidateClicked(!isValidateClicked);
    }

    function saleSupportExistInShopsActivated() {
        let isIdExist;
        let idsAssociated: any = [];
        shopsSaleSupportData.forEach((el: any) => {
            el.subRows.forEach((element: any) => {
                idsAssociated.push(element.Id);
            });
        });

        selectedRows.forEach((el: any) => {
            if (idsAssociated.includes(el.Id)) {
                isIdExist = true;
            }
        });
        if (isIdExist === true) {
            setIsModalConfirmationOpened(!isModalConfirmationOpened);
        } else {
            !isArchivedSaleSupportClicked
                ? setIsArchivedValidationModalOpened(true)
                : handleArchiveSaleSupport(false);
        }
    }
    const handleAddSalesMethodClick = async () => {
        try {
            const configs = await GetSalesModesTypesAndTagsV2(
                franchiseID,
                shopId,
                fetchGlobal
            );

            const data = configs[0];

            if (!data) return;
            setSalesModesTypesAndTag(data);
            setLocalFilterActive(false);
            setIsAddSaleSupportClicked(true);
        } catch (error) {
            console.error("Error fetching sales modes and tags:", error);
        }
    };
    React.useEffect(() => {
        if (isValidateClicked) {
            handleArchiveSaleSupport(isActive);
        }
        // eslint-disable-next-line
    }, [isValidateClicked, isActive]);
    return (
        <div className="d-flex justify-content-start align-items-center ml-2">
            {modify === true ? (
                <>
                    {isAddSaleSupportClicked !== true ? (
                        <span
                            onClick={async () => {
                                await handleAddSalesMethodClick();
                            }}
                            className={`${classnames(
                                "w-100 ml-2 cmn_btn_openForm",
                                {
                                    "not-allowed-icon__clz":
                                        isArchivedSaleSupportClicked ||
                                        isLoading,
                                }
                            )}`}
                        >
                            <CustomMainColorButtonWithIcon
                                icon="PlusIcon"
                                iconPosition="left"
                                rounded
                                variant="primary"
                                onClick={() => {
                                    setIsInlineErrorCleared(
                                        !isInlineErrorCleared
                                    );
                                }}
                            >
                                {t("Add a sale support")}
                            </CustomMainColorButtonWithIcon>
                        </span>
                    ) : (
                        <CustomMainColorIconButton
                            icon="PlusIcon"
                            className="sdv_btn_FRreset "
                            rounded
                            disabled={
                                saleSupport.Id !== undefined ? true : false
                            }
                            onClick={() => {
                                if (isEdited === true) {
                                    setIsInInitializationModalOpened(true);
                                } else {
                                    setIsInlineErrorCleared(true);
                                }
                            }}
                        >
                            <PlusIcon height={20} width={20} fill="white" />
                        </CustomMainColorIconButton>
                    )}
                </>
            ) : null}

            <VerticalDotsIcon
                className="cmn_drp_FRmenu"
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                style={{ cursor: "pointer" }}
                height={25}
                width={25}
                fill="black"
            />
            <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                <div
                    style={{ cursor: "pointer" }}
                    className={classnames(
                        "dropdown-item pl-1 cmn_btn_FRlistActivated"
                    )}
                    onClick={() => {
                        setIsArchivedSaleSupportClicked(false);
                    }}
                >
                    {t("Enabled sales support")} ({numberActive})
                </div>
                <div
                    style={{ cursor: "pointer" }}
                    className={classnames(
                        "dropdown-item pl-1 cmn_btn_FRlistArchived "
                    )}
                    onClick={() => {
                        if (isEdited === true) {
                            setIsActionsClicked(!isActionsClicked);
                            setActions(() => {
                                setIsEdited(false);
                                setIsArchivedSaleSupportClicked(true);
                                setIsAddSaleSupportClicked(false);
                            });
                        } else {
                            setIsArchivedSaleSupportClicked(true);
                            setIsAddSaleSupportClicked(false);
                        }
                    }}
                >
                    {t("Archived sales Support")} ({numberArchived})
                </div>
                <div
                    style={{ cursor: "pointer" }}
                    className={`${classnames(
                        "dropdown-item pl-1  cmn_btn_FRhistory",
                        {
                            "not-allowed-icon__clz":
                                selectedRows.length === 0 || isLoading,
                        }
                    )}`}
                    onClick={() => {
                        if (isEdited === true) {
                            setIsActionsClicked(!isActionsClicked);
                            setActions(() => {
                                setIsEdited(false);
                                setIsAddSaleSupportClicked(false);
                                if (selectedRows.length === 1) {
                                    ErrorToast(
                                        `${t(
                                            "Attention, it is a multiple action. Please select at least two items"
                                        )!}`
                                    );
                                } else
                                    setIsHistoryModalOpened(
                                        !isHistoryModalOpened
                                    );
                            });
                        } else {
                            if (selectedRows.length === 1) {
                                ErrorToast(
                                    `${t(
                                        "Attention, it is a multiple action. Please select at least two items"
                                    )!}`
                                );
                            } else
                                setIsHistoryModalOpened(!isHistoryModalOpened);
                        }
                    }}
                >
                    {t("Historical")}
                </div>
                {modify === true ? (
                    <>
                        <div
                            style={{ cursor: "pointer" }}
                            className={`${classnames(
                                "dropdown-item pl-1 cmn_btn_FRarchived cmn_btn_FRunarchive",
                                {
                                    "not-allowed-icon__clz":
                                        isLoading ||
                                        selectedRows.length === 0 ||
                                        (isArchivedSaleSupportClicked &&
                                            oneShop &&
                                            selectedRows.some((element: any) =>
                                                dataArchive.includes(element.Id)
                                            )),
                                }
                            )}`}
                            onClick={() => {
                                if (isEdited === true) {
                                    setIsLoading(false);
                                    setIsActionsClicked(!isActionsClicked);
                                    setActions(() => {
                                        setIsEdited(false);
                                        setIsAddSaleSupportClicked(false);
                                        if (selectedRows.length === 1) {
                                            ErrorToast(
                                                `${t(
                                                    "Attention, it is a multiple action. Please select at least two items"
                                                )!}`
                                            );
                                        } else if (
                                            !isArchivedSaleSupportClicked
                                        ) {
                                            saleSupportExistInShops(
                                                shopsSaleSupportData,
                                                selectedRows,
                                                oneShop,
                                                setIsArchivedValidationModalOpened
                                            );
                                            setIsActive(true);
                                        } else {
                                            saleSupportExistInShopsActivated();
                                            setIsActive(false);
                                        }
                                    });
                                } else {
                                    if (selectedRows.length === 1) {
                                        ErrorToast(
                                            `${t(
                                                "Attention, it is a multiple action. Please select at least two items"
                                            )!}`
                                        );
                                    } else if (!isArchivedSaleSupportClicked) {
                                        saleSupportExistInShops(
                                            shopsSaleSupportData,
                                            selectedRows,
                                            oneShop,
                                            setIsArchivedValidationModalOpened
                                        );
                                        setIsActive(true);
                                    } else {
                                        saleSupportExistInShopsActivated();
                                        setIsActive(false);
                                    }
                                }
                            }}
                        >
                            {isArchivedSaleSupportClicked
                                ? t("Unarchive")
                                : t("Archive")}
                        </div>
                    </>
                ) : null}
            </div>
            {isArchivedValidationModalOpened ? (
                <ConfirmationArchive
                    isArchiveSVModalOpened={isArchivedValidationModalOpened}
                    setIsArchiveSVModalOpened={
                        setIsArchivedValidationModalOpened
                    }
                    setIsValidateClicked={setIsValidateClicked}
                />
            ) : null}
        </div>
    );
}
